import { toType } from '../utils';

function lazyLoaderService ($window, viewport) {
    function isViewport(key) {
        switch (key) {
            case 'Desktop':
                return viewport.isAtLeastDesktop();
            case 'Tablet' :
                return viewport.isTablet();
            case 'Mobile' :
                return viewport.isMobile();
            default:
                return false;
        }
    }

    function isBoundingCase(bound){
        const {key, rect, offset, widthBounding, heightBounding} = bound;
        const bounds = {
            left: (rect.left >= 0 && (rect.left + offset) <= widthBounding),
            top: (rect.top >= 0 && (rect.top + offset) <= heightBounding),
            right: (rect.right >= 0 && (rect.right + offset) <= widthBounding),
            bottom: (rect.bottom >= 0 && (rect.bottom + offset) <= heightBounding)
        };
        return bounds[key] || false;
    }

    function getBoundingCase(rect, bounding) {
        let heightBounding = $window.innerHeight,
            widthBounding = $window.innerWidth,
            boundingCase = (rect.top >= 0 && rect.bottom <= heightBounding);


        if (bounding && bounding.length > 0 && toType(bounding) === 'array') {
            boundingCase = bounding.map(function (bound) {
                let key, offset;
                if (typeof bound === 'string') {
                    key = bound;
                    offset = 0;
                } else if (typeof bound === 'object') {
                    if (Object.keys(bound).length > 1) {
                        return false;
                    } else {
                        key = Object.keys(bound).toString();
                        offset = bound[key];

                        if (angular.isArray(offset)) {
                            if (isViewport(key)) {
                                return offset.map(function (subBound) {
                                    const subKey = Object.keys(subBound).toString();
                                    const subOffset = subBound[subKey];
                                    bound = {
                                        key: subKey, rect, offset: subOffset, widthBounding, heightBounding
                                    };
                                    return isBoundingCase(bound);
                                }).every(function(e) { return e; });
                            } else {
                                return true;
                            }
                        }
                    }
                }

                bound = {key, rect, offset, widthBounding, heightBounding};
                return isBoundingCase(bound);

            }).every(function(e) { return e; });
        }

        return boundingCase;
    }

    return {
        getBoundingCase
    };
}

lazyLoaderService.$inject = ['$window', 'viewport'];

export default lazyLoaderService;
